export default __webpack_public_path__ + "static/media/flyingLogo.d1fca681.png";